export default __webpack_public_path__ + "static/media/cb8.49e2f05f.jpeg";